<template>
  <div class="articlePage pageWhite pagePadding">
    <el-form label-width="120px" class="formBox fb-10" inline v-show="!isEdit">
      <el-form-item label="姓名">{{ descJson.name }}</el-form-item>
      <el-form-item label="身份证号">{{ descJson.idCard }}</el-form-item>
      <el-form-item label="性别">{{ descJson.sex|sex }}</el-form-item>
      <el-form-item label="学历">{{ descJson.academic|academic }}</el-form-item>
      <el-form-item label="籍贯">{{ descJson.birthplace }}</el-form-item>
      <el-form-item label="毕业院校">{{ descJson.universityName }}</el-form-item>
      <el-form-item label="毕业年份">{{ descJson.graduation }}年</el-form-item>
      <el-form-item label="专业">{{ descJson.specializedId }}</el-form-item>
      <el-form-item label="手机号码">{{ descJson.phone }}</el-form-item>
      <el-form-item label="本人微信">{{ descJson.wechat }}</el-form-item>
      <el-form-item label="本人QQ">{{ descJson.qq }}</el-form-item>
      <el-form-item label="家人电话">{{ descJson.familyPhone }}</el-form-item>
      <el-form-item label="托管项目">档案</el-form-item>
      <el-form-item label="现档案所在机构">{{ descJson.mechanism }}</el-form-item>
      <el-form-item label="现居住地址">{{ descJson.residentialAddress }}</el-form-item>
      <el-form-item label="工作单位">{{ descJson.employer }}</el-form-item>
      <el-form-item label="缴纳社保">{{ descJson.paySocialSecurity ? '是' : '否' }}</el-form-item>
      <el-form-item label="政治面貌">{{ descJson.politicalStatus|political }}</el-form-item>
      <el-form-item label="入党时间" v-if="descJson.partyTime">{{ descJson.partyTime }}</el-form-item>
      <el-form-item label="材料附件" class="fm-100">
        <div class="fm-img" v-if="descJson.idCardFront">
          <el-image :src="imgList.idCardFront" :preview-src-list="[imgList.idCardFront]"></el-image>
        </div>
        <div class="fm-img" v-if="descJson.idCardObverse">
          <el-image :src="imgList.idCardObverse" :preview-src-list="[imgList.idCardObverse]"></el-image>
        </div>
        <div class="fm-img" v-if="descJson.diploma">
          <el-image :src="imgList.diploma" :preview-src-list="[imgList.diploma]"></el-image>
        </div>
        <div class="fm-img" v-if="descJson.proofOfFiling">
          <el-image :src="imgList.proofOfFiling" :preview-src-list="[imgList.proofOfFiling]"></el-image>
        </div>
        <div class="fm-img" v-if="descJson.proofOfEmployment">
          <el-image :src="imgList.proofOfEmployment" :preview-src-list="[imgList.proofOfEmployment]"></el-image>
        </div>
      </el-form-item>
      <el-form-item class="fm-100">
        <el-button type="primary" @click="toEditInfo">修改信息</el-button>
        <el-button type="success" v-if="descJson.auditStatus!=1" @click="toPass">通过审核</el-button>
        <el-button type="warning" v-if="descJson.auditStatus!=0" @click="toReject">驳回审核</el-button>
        <el-button type="danger" v-if="role==1" @click="toDel">删除申请</el-button>
      </el-form-item>
    </el-form>
    <el-form :model="formData" label-width="120px" class="formBox" inline v-show="isEdit" :rules="rules" ref="form">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="formData.name" class="fm-200"></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="idCard">
        <el-input placeholder="请输入身份证号" v-model="formData.idCard" @blur="toSetSex" class="fm-200"></el-input>
      </el-form-item>
      <el-form-item label="性别" prop="sex">
        <el-select v-model="formData.sex" :disabled="sexDisabled" class="fm-200">
          <el-option label="男" value="1"></el-option>
          <el-option label="女" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学历" prop="academic">
        <el-select v-model="formData.academic" class="fm-200">
          <el-option label="专科" :value="1"></el-option>
          <el-option label="本科" :value="2"></el-option>
          <el-option label="硕士" :value="3"></el-option>
          <el-option label="博士" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="籍贯" prop="birthplace">
        <el-cascader :props="cascaderOptions" v-model="formData.birthplace" :placeholder="cityName"
                     ref="birthplace" @change="changeBirthplace" class="fm-200"></el-cascader>
      </el-form-item>
      <el-form-item label="毕业院校" prop="university">
        <el-select v-model="formData.university" filterable class="fm-200">
          <el-option v-for="item in schoolList" :key="item.value" :label="item.label" :value="item.value"
                     :disabled="item.isClose==1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="毕业年份" prop="graduation">
        <el-select v-model="formData.graduation" class="fm-200">
          <el-option v-for="(item,index) in graduationList" :key="index" :label="item.label"
                     :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="专业" prop="specializedId">
        <el-input placeholder="请输入专业" v-model="formData.specializedId" class="fm-200"></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="phone">
        <el-input placeholder="请输入手机号码" v-model="formData.phone" class="fm-200"></el-input>
      </el-form-item>
      <el-form-item label="本人微信" prop="wechat">
        <el-input placeholder="请输入微信" v-model="formData.wechat" class="fm-200"></el-input>
      </el-form-item>
      <el-form-item label="本人QQ" prop="qq">
        <el-input placeholder="请输入QQ号" v-model="formData.qq" class="fm-200"></el-input>
      </el-form-item>
      <el-form-item label="家人电话" prop="familyPhone">
        <el-input placeholder="请输入家人电话" v-model="formData.familyPhone" class="fm-200"></el-input>
      </el-form-item>
      <el-form-item label="托管项目">
        <el-checkbox v-model="isTrue" disabled>档案</el-checkbox>
      </el-form-item>
      <el-form-item label="现档案所在机构" prop="mechanism">
        <el-input placeholder="请输入现档案所在机构" v-model="formData.mechanism" class="fm-200"></el-input>
      </el-form-item>
      <el-form-item label="现居住地址" prop="residentialAddress">
        <el-input placeholder="请输入现居住地址" v-model="formData.residentialAddress" class="fm-200"></el-input>
      </el-form-item>
      <el-form-item label="工作单位" prop="employer">
        <el-input placeholder="请输入工作单位" v-model="formData.employer" class="fm-200"></el-input>
      </el-form-item>
      <el-form-item label="缴纳社保" prop="paySocialSecurity">
        <el-switch v-model="formData.paySocialSecurity"></el-switch>
      </el-form-item>
      <el-form-item label="政治面貌" prop="politicalStatus">
        <el-select class="fm-200" v-model="formData.politicalStatus">
          <el-option v-for="item in politicalStatusList" :key="item.value" :label="item.label"
                     :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="入党时间" prop="partyTime" v-if="formData.politicalStatus&&formData.politicalStatus<11"
                    :rules="[{required:formData.politicalStatus<11,message:'请选择入党日期',trigger:'blur'}]">
        <el-date-picker
          v-model="formData.partyTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择入党时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="身份证正面" prop="idCardFront" class="fm-100">
        <div class="fm-img">
          <img :src="uploadList.idCardFront" alt="" v-if="uploadList.idCardFront">
          <img :src="imgList.idCardFront" alt="" v-else-if="descJson.idCardFront">
          <div v-else class="noneImg">暂无身份证正面图片</div>
          <div class="fm-mark">
            <div class="btn-box">
              <el-upload action="" accept=".png,.jpg,.jpeg,.bmp,.gif" :auto-upload="false" list-type="picture-card"
                         :limit="1" :on-change="(f)=>{toChange(f,'idCardFront')}"
                         :on-remove="(f)=>{toDelImg(f,'idCardFront')}" ref="idCardFront">
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="身份证反面" prop="idCardObverse" class="fm-100">
        <div class="fm-img">
          <img :src="uploadList.idCardObverse" alt="" v-if="uploadList.idCardObverse">
          <img :src="imgList.idCardObverse" alt="" v-else-if="descJson.idCardObverse">
          <div v-else class="noneImg">暂无身份证反面图片</div>
          <div class="fm-mark">
            <div class="btn-box">
              <el-upload action="" accept=".png,.jpg,.jpeg,.bmp,.gif" :auto-upload="false" list-type="picture-card"
                         :limit="1" :on-change="(f)=>{toChange(f,'idCardObverse')}"
                         :on-remove="(f)=>{toDelImg(f,'idCardObverse')}" ref="idCardObverse">
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="毕业证书扫描件" prop="diploma" class="fm-100">
        <div class="fm-img">
          <img :src="uploadList.diploma" alt="" v-if="uploadList.diploma">
          <img :src="imgList.diploma" alt="" v-else-if="descJson.diploma">
          <div v-else class="noneImg">暂无毕业证书扫描件</div>
          <div class="fm-mark">
            <div class="btn-box">
              <el-upload action="" accept=".png,.jpg,.jpeg,.bmp,.gif" :auto-upload="false" list-type="picture-card"
                         :limit="1" :on-change="(f)=>{toChange(f,'diploma')}"
                         :on-remove="(f)=>{toDelImg(f,'diploma')}" ref="diploma">
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="存档证明描述件" prop="proofOfFiling" class="fm-100">
        <div class="fm-img">
          <img :src="uploadList.proofOfFiling" alt="" v-if="uploadList.proofOfFiling">
          <img :src="imgList.proofOfFiling" alt="" v-else-if="descJson.proofOfFiling">
          <div v-else class="noneImg">暂无存档证明描述件</div>
          <div class="fm-mark">
            <div class="btn-box">
              <el-upload action="" accept=".png,.jpg,.jpeg,.bmp,.gif" :auto-upload="false" list-type="picture-card"
                         :limit="1" :on-change="(f)=>{toChange(f,'proofOfFiling')}"
                         :on-remove="(f)=>{toDelImg(f,'proofOfFiling')}" ref="proofOfFiling">
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="工作证明扫描件" prop="proofOfEmployment" class="fm-100">
        <div class="fm-img">
          <img :src="uploadList.proofOfEmployment" alt="" v-if="uploadList.proofOfEmployment">
          <img :src="imgList.proofOfEmployment" alt="" v-else-if="descJson.proofOfEmployment">
          <div v-else class="noneImg">暂无工作证明扫描件</div>
          <div class="fm-mark">
            <div class="btn-box">
              <el-upload action="" accept=".png,.jpg,.jpeg,.bmp,.gif" :auto-upload="false" list-type="picture-card"
                         :limit="1" :on-change="(f)=>{toChange(f,'proofOfEmployment')}"
                         :on-remove="(f)=>{toDelImg(f,'proofOfEmployment')}" ref="proofOfEmployment">
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item class="fm-100">
        <el-button type="primary" @click="sure">确认提交</el-button>
      </el-form-item>
    </el-form>
    <el-dialog :visible.sync="rejectDialog" title="驳回申请" append-to-body width="350px">
      <el-form :model="rejectForm" label-width="100px" ref="rejectForm">
        <el-form-item label="备注内容" prop="remark" :rules="{required:true,message:'请输入备注',trigger:'blur'}">
          <el-input type="textarea" placeholder="请输入备注" v-model="rejectForm.remark"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="toRejectSure">确定驳回</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import {mapState} from 'vuex'
import $updateFile from '@/assets/js/uploadFile'
import provinces from '@/assets/js/city-data/province'
import citys from '@/assets/js/city-data/city'
import areas from '@/assets/js/city-data/area'
import {validatorCard, compress, validatorQQ} from '@/assets/js/common'

export default {
  data () {
    let getValue = (node) => {
      let level = node.level
      if (level === 0) {
        return provinces.map((item, pi) => ({
          value: item.value,
          label: item.label,
          vid: pi
        }))
      } else if (level === 1) {
        let uid = node.data.vid
        this.cPath[0] = uid
        return citys[uid].map((item, ci) => ({
          value: item.value,
          label: item.label,
          vid: ci
        }))
      } else if (level === 2) {
        let uid = node.data.vid
        this.cPath[1] = uid
        return areas[this.cPath[0]][uid].map((item, ai) => ({
          value: item.value,
          label: item.label,
          leaf: true
        }))
      }
    }
    let qqCheck = (rule, value, cb) => {
      if (value) {
        if (validatorQQ(value)) {
          cb()
        } else {
          cb(new Error('qq号格式不正确'))
        }
      } else {
        cb(new Error('请输入qq号'))
      }
    }
    let IDCard = (rule, value, cb) => {
      if (value) {
        if (validatorCard(value)) {
          cb()
        } else {
          cb(new Error('身份证格式不正确'))
        }
      } else {
        cb(new Error('请输入身份证号'))
      }
    }
    return {
      descID: '',
      isEdit: false,
      isTrue: true,
      rejectForm: {
        remark: ''
      },
      rejectDialog: false,
      formData: {
        name: '',
        idCard: '',
        sex: '',
        academic: '',
        birthplace: '',
        university: '',
        graduation: '',
        specializedId: '',
        phone: '',
        wechat: '',
        qq: '',
        familyPhone: '',
        mechanism: '',
        residentialAddress: '',
        employer: '',
        fileCustody: 1,
        paySocialSecurity: false,
        politicalStatus: '',
        partyTime: '',
        idCardFront: '',
        idCardObverse: '',
        proofOfEmployment: '',
        diploma: '',
        proofOfFiling: ''
      },
      rules: {
        name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
        idCard: [{
          validator: IDCard, trigger: ['blur'], required: true
        }],
        sex: [{required: true, message: '请选择性别'}],
        academic: [{required: true, message: '请选择学历', trigger: 'change'}],
        birthplace: {
          required: true,
          message: '请选择籍贯'
        },
        university: {
          required: true,
          message: '请选择毕业院校'
        },
        graduation: {
          required: true,
          message: '请选择毕业年份'
        },
        specializedId: {
          required: true,
          message: '请输入专业'
        },
        phone: [{required: true, message: '请输入手机号', trigger: 'blur'},
          {pattern: /^1\d{10}$/, message: '手机号格式不正确', trigger: 'blur'}],
        familyPhone: [{required: true, message: '请输入家人手机号', trigger: 'blur'},
          {pattern: /^1\d{10}$/, message: '家人手机号格式不正确', trigger: 'blur'}],
        qq: [
          {
            validator: qqCheck, trigger: ['blur'], required: true
          }
        ],
        wechat: {
          required: true,
          message: '请输入微信号'
        },
        mechanism: {
          required: true,
          message: '请输入现档案所在机构'
        },
        residentialAddress: {
          required: true,
          message: '请输入现居住地址'
        },
        employer: {
          required: true,
          message: '请输入工作单位'
        },
        politicalStatus: {
          required: true,
          message: '请选择政治面貌'
        },
        idCardFront: {
          required: true,
          message: '请上传身份证正面'
        },
        idCardObverse: {
          required: true,
          message: '请上传身份证反面'
        },
        diploma: {
          required: true,
          message: '请上传毕业证书扫描件'
        },
        proofOfFiling: {
          required: true,
          message: '请上传存档证明描述件'
        }
      },
      descJson: {},
      imgList: {},
      graduationList: [],
      cascaderOptions: {
        lazy: true,
        lazyLoad (node, resolve) {
          let nodes = getValue(node)
          resolve(nodes)
        }
      },
      cPath: [0, 0, 0],
      cityName: '',
      politicalStatusList: [
        {
          label: '群众',
          value: '12'
        }, {
          label: '中共党员',
          value: '1'
        }, {
          label: '中共预备党员',
          value: '2'
        }, {
          label: '共青团员',
          value: '3'
        }, {
          label: '民革党员',
          value: '4'
        }, {
          label: '民盟盟员',
          value: '5'
        }, {
          label: '民进会员',
          value: '6'
        }, {
          label: '农工党党员',
          value: '7'
        }, {
          label: '致公党党员',
          value: '8'
        }, {
          label: '九三学社社员',
          value: '9'
        }, {
          label: '台盟盟员',
          value: '10'
        }, {
          label: '无党派人士',
          value: '11'
        }],
      uploadList: {
        idCardFront: '',
        idCardObverse: '',
        diploma: '',
        proofOfFiling: '',
        proofOfEmployment: ''
      },
      uploadFiles: {
        idCardFront: '',
        idCardObverse: '',
        diploma: '',
        proofOfFiling: '',
        proofOfEmployment: ''
      },
      sexDisabled: false
    }
  },
  created () {
    this.descID = this.$route.params.id
    this.getDesc()
    this.getYearsList()
  },
  computed: {
    ...mapState({
      role: state => state.base.userInfo.role,
      schoolList: state => state.school.schoolList
    })
  },
  methods: {
    getYearsList () {
      let nowY = new Date().getFullYear()
      let arr = []
      for (let j = nowY - 1; j >= 1990; j--) {
        arr.push({
          label: j + '年',
          value: j
        })
      }
      this.graduationList = arr
    },
    getDesc () {
      this.$api.getDesc(this.descID, res => {
        this.descJson = JSON.parse(JSON.stringify(res))
        for (let j in this.formData) {
          this.formData[j] = res[j]
          if (j === 'birthplace') {
            this.cityName = res[j]
          }
          if (j === 'sex') {
            this.formData[j] = String(res[j])
          }
          if (j === 'idCardFront' || j === 'idCardObverse' || j === 'proofOfEmployment' || j === 'diploma' || j === 'proofOfFiling') {
            this.downloadImg(res[j], j)
          }
        }
      })
    },
    downloadImg (dUrl, key) {
      if (dUrl) {
        let fileType = this.descJson.openId
        $updateFile(fileType, dUrl, (url) => {
          this.$set(this.imgList, key, url)
        }, 1)
      }
    },
    toDel () {
      this.$confirm('确认删除:' + this.descJson.name + '的申请,是否继续?', '删除申请', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.delApply(this.descID, () => {
          this.$message.success('删除成功！')
          this.$router.replace({path: '/previous'})
        })
      }).catch(() => {
      })
    },
    toPass () {
      this.$confirm('确认' + this.descJson.name + '的申请审核通过?', '审核', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.editApply(this.descID, {auditStatus: 1}, () => {
          this.$message.success('操作成功！')
          this.getDesc()
        })
      }).catch(() => {
      })
    },
    toReject () {
      this.rejectDialog = true
    },
    toRejectSure () {
      this.$refs.rejectForm.validate(valid => {
        if (valid) {
          this.$api.editApply(this.descID, {auditStatus: 0, remark: this.rejectForm.remark}, () => {
            this.$message.success('操作成功！')
            this.rejectDialog = false
            this.$router.back()
          })
        }
      })
    },
    toEditInfo () {
      this.isEdit = true
    },
    toSetSex () {
      let val = this.formData.idCard
      if (val.length === 15 || val.length === 18) {
        validatorCard(val, (birth, sex) => {
          this.formData['sex'] = parseInt(sex) % 2 === 1 ? '1' : '2'
          this.sexDisabled = true
        })
      } else {
        this.formData['sex'] = ''
        this.sexDisabled = false
      }
    },
    sure () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.formData['phone'] === this.formData['familyPhone']) {
            this.$message.warning('手机号与家人的不能一致')
            return false
          }
          let isTime = Number(this.formData['politicalStatus']) < 11 && !this.formData['partyTime']
          if (isTime) {
            this.$message.warning('请选择入党日期')
            return false
          }
          // 上传修改以后的图片
          let pLen = 5
          for (let j in this.uploadList) {
            this.toUpload(j, () => {
              if (pLen === 1) {
                let form = JSON.parse(JSON.stringify(this.formData))
                form['birthplace'] = this.cityName
                this.$api.editApply(this.descID, form, () => {
                  this.$message.success('提交成功')
                  this.getDesc()
                  this.isEdit = false
                })
              } else {
                pLen--
              }
            })
          }
        } else {
          this.$message.error('信息填写有误,请检查后在提交')
        }
      })
    },
    changeBirthplace () {
      this.cityName = this.$refs.birthplace.getCheckedNodes()[0].pathLabels.join('/')
    },
    toImg (url) {
      window.location.href = url
    },
    toChange (file, key) {
      this.uploadFiles[key] = file
      this.$set(this.uploadList, key, file.url)
      this.formData[key] = 'isUpdate'
    },
    toDelImg (f, key) {
      this.uploadFiles[key] = ''
      this.$set(this.uploadList, key, '')
      this.uploadFiles[key] = ''
      this.formData[key] = ''
    },
    toUpload (key, back) {
      if (this.uploadList[key]) {
        let file = this.uploadFiles[key]['raw']
        let rgx = '(.png|.gif|.jpg|.jpeg|.bmp)'
        let re = new RegExp(rgx, 'i')
        let isFormat = re.test(file.name)
        let isSize = file.size / 1024 / 1024 < 10
        if (!isFormat) {
          this.$message.error('文件格式有误,请选择图片格式!')
          return false
        }
        if (!isSize) {
          this.$message.error('上传文件大小不能超过10M！')
          return false
        } else {
          if (isFormat) {
            compress(file, {quality: 0.3}, (nFile) => {
              let fileType = this.descJson.openId || this.descJson.id
              $updateFile(fileType, nFile, (nKey) => {
                this.formData[key] = nKey
                back()
              }, 0, this.descJson[key])
            })
          }
        }
      } else {
        back()
      }
    }
  },
  filters: {
    sex (s) {
      return ['', '男', '女'][s]
    },
    academic (a) {
      return ['', '专科', '本科', '硕士', '博士'][a]
    },
    political (p) {
      return ['', '中共党员', '中共预备党员', '共青团员', '民革党员', '民盟盟员', '民进会员', '农工党党员', '致公党党员', '九三学社社员', '台盟盟员', '无党派人士', '群众'][p]
    }
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
.el-upload-list {
  display: none;
}

.formBox {
  width: 90%;
  min-width: 600px;
  margin: 0 auto;

  &.fb-10 {
    .el-form-item {
      margin-bottom: 10px;
    }

    .fm-img {
      width: 48%;
    }
  }

  .el-form-item {
    width: 47%;

    &.fm-100 {
      width: 97%;
    }

    .fm-200 {
      width: 200px;
    }

    .fm-img {
      width: 500px;
      display: inline-block;
      vertical-align: top;
      padding-bottom: 5px;
      position: relative;
      height: 320px;
      overflow: hidden;

      img {
        display: block;
        width: 100%;
        max-height: 100%;
      }

      .noneImg {
        width: 100%;
        height: 100%;
        line-height: 320px;
        text-align: center;
        font-size: 14px;
        color: #999;
      }

      .fm-mark {
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, .5);
        text-align: center;
        right: 0;
        bottom: 5px;
        z-index: 5;
        opacity: 0;

        .btn-box {
          position: absolute;
          left: 0;
          top: 50%;
          margin-top: -18px;
          right: 0;
          height: 36px;
        }
      }

      &:hover {
        .fm-mark {
          opacity: 1;
        }
      }
    }
  }
}

.toNewPage {
  display: inline-block;
  width: 80px;
  border: 1px solid #81c683;
  color: #81c683;
  font-size: 14px;
  line-height: 34px;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/main/desc.vue